import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppStateModule } from './app-state.module';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {
  MsalGuard,
  MsalInterceptor,
  MsalModule,
  MsalRedirectComponent,
} from '@azure/msal-angular';
import {
  BrowserCacheLocation,
  InteractionType,
  PublicClientApplication,
} from '@azure/msal-browser';
import { environment } from '../environments/environment';
import { AppComponent } from './app.component';
import { TokenInterceptor } from './qcrop/interceptors/token.interceptor';

const isIE =
  window.navigator.userAgent.indexOf('MSIE ') > -1 ||
  window.navigator.userAgent.indexOf('Trident/') > -1;

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    HttpClientModule,
    BrowserAnimationsModule,
    AppStateModule,
    AppRoutingModule,
    NgbModule,
    MsalModule.forRoot(
      new PublicClientApplication({
        auth: {
          clientId: environment.msalConfig.auth.clientId,
          authority: environment.msalConfig.auth.authority,
        },
        cache: {
          cacheLocation: BrowserCacheLocation.LocalStorage,
          storeAuthStateInCookie: isIE,
        },
      }),
      {
        interactionType: InteractionType.Redirect,
        authRequest: {
          scopes: [
            'user.read',
            'api://767f54a2-1ce2-4397-b45d-4f7a52f0d537/default',
          ],
        },
      },
      {
        interactionType: InteractionType.Redirect,
        protectedResourceMap: new Map([
          ['https://graph.microsoft.com/v1.0/me', ['user.read']],
          [
            `${environment.apiUrl}/api/company`,
            ['api://767f54a2-1ce2-4397-b45d-4f7a52f0d537/default'],
          ],
          [
            `${environment.apiUrl}/api/project`,
            ['api://767f54a2-1ce2-4397-b45d-4f7a52f0d537/default'],
          ],
          [
            `${environment.apiUrl}/api/source`,
            ['api://767f54a2-1ce2-4397-b45d-4f7a52f0d537/default'],
          ],
          [
            `${environment.apiUrl}/api/blobSource`,
            ['api://767f54a2-1ce2-4397-b45d-4f7a52f0d537/default'],
          ],
          [
            `${environment.apiUrl}/api/user`,
            ['api://767f54a2-1ce2-4397-b45d-4f7a52f0d537/default'],
          ],
          [
            `${environment.apiUrl}/api/user`,
            ['api://767f54a2-1ce2-4397-b45d-4f7a52f0d537/default'],
          ],
          [
            `${environment.apiUrl}/api/AzureMarketplace`,
            ['api://767f54a2-1ce2-4397-b45d-4f7a52f0d537/default'],
          ],
        ]),
      }
    ),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    MsalGuard,
  ],
  bootstrap: [AppComponent, MsalRedirectComponent],
})
export class AppModule {}
